import React, { Suspense, Fragment, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Loader from 'common-ui/lib/common/Layout/Layout';
import Wrapper from './Wrapper';
import Cookies from 'js-cookie';
import LayoutRoutes from './LayoutRoutes';

const Routers = () => {
    const [authenticated, setAuthenticated] = useState(false);
    const jwt_token = Cookies.get('jwtToken');

    useEffect(() => {
        let abortController = new AbortController();
        setAuthenticated(Cookies.get('jwtToken') ? true : false);
        console.ignoredYellowBox = ['Warning: Each', 'Warning: Failed'];
        console.disableYellowBox = true;
        return () => {
            abortController.abort();
        };
    }, []);
    const userType = sessionStorage.getItem('userType');

    return (
        <Fragment>
            <BrowserRouter basename='/'>
                <Wrapper>
                    <Suspense fallback={<Loader />}>
                        <Routes >
                            <Route path={`/*`} element={<LayoutRoutes />} />
                        </Routes>
                    </Suspense>
                </Wrapper>
            </BrowserRouter>
        </Fragment>
    )
}

export default Routers;